import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Layout from './components/Layout';
import { BrowserRouter } from 'react-router-dom';
import { GlobalStoreProvider } from './context';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalStoreProvider>
        <Layout>
          <App />
        </Layout>
      </GlobalStoreProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
